import { xstate } from '@upflowy/types';
import { ActionTypes } from 'xstate';

import { IContext, StartAbTestAction } from '../types';

export const abTestAssignment =
  (randomGenerator: () => number) =>
  (
    { abtests }: IContext,
    event: xstate.StateEvent,
    {
      action,
    }: {
      action: StartAbTestAction;
    },
  ) => {
    if (abtests?.[action.name]) return abtests;
    const randomNumber = randomGenerator() * 100;
    let sum = 0;
    const allocation =
      action.variations
        .map((variation) => ({
          ...variation,
          allocation: Number(variation.allocation.match(/([\d.]+)%/)?.[1]),
        }))
        .find(({ allocation: alloc }) => {
          if (randomNumber >= sum && randomNumber < alloc + sum) return true;
          sum += alloc;
          return false;
        }) ?? action.variations[action.variations.length - 1];

    if (allocation?.name) {
      return {
        ...abtests,
        [action.name]: allocation.name,
      };
    }

    return abtests;
  };

export const startAbTest = {
  type: ActionTypes.Assign,
  assignment: {
    abtests: abTestAssignment(Math.random),
  },
};
